import store, { RootState } from "../../store/store";
import Player from "../Players/Player";
import "./Lobby.scss";
import classNames from 'classnames';
import LobbySettings from "./LobbySettings";
import { useAppSelector } from "../../hooks/redux";

export default function Lobby() {

  const gameState = useAppSelector((state: RootState) => state.game);

  const players = gameState.players;
  const player = gameState.player;

  return (
    <div className="lobby">
      <div className="lobby_players">
        {players.map((it) => {
          const isClient = player?.data.playerId === it.playerId;
          const classes = classNames({
            'player_highlight': it.playerId === gameState.hostId,
            'player_client': it.playerId === gameState.player?.data.playerId,
          });
          return <Player classes={classes} player={it} key={it.playerId} isClient={isClient} size={76} statsVisible={false} />;
        })}
      </div>
      <LobbySettings />
    </div>
  )
}